const carouselItems = [
  {
    title: '2026年度华语电影之光',
    subtitle: '年度盘点',
    desc: '回顾2026上半年最值得铭记的华语电影时刻，从票房黑马到口碑佳作，密桃视频为您一一细数那些打动人心的银幕故事。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20award%20show%20stage%20with%20dramatic%20golden%20spotlights%2C%20elegant%20film%20industry%20aesthetic%2C%20luxurious%20dark%20and%20amber%20lighting%2C%20prestigious%20atmosphere%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '久久视频：经典修复计划第二期',
    subtitle: '经典重映',
    desc: '久久视频专区持续推进华语经典电影数字修复工程，第二期50部影片已完成4K修复，老片新看，清晰如初。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Vintage%20film%20archive%20with%20old%20movie%20reels%20and%20projector%2C%20warm%20sepia%20and%20golden%20lighting%2C%20nostalgic%20cinema%20atmosphere%2C%20classic%20Hollywood%20aesthetic%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '悬疑片单：50部烧脑神作一次看过瘾',
    subtitle: '专题策划',
    desc: '从心理惊悚到本格推理，密桃视频精选50部高智商悬疑佳作。反转、伏笔、细思极恐，每一部都值得反复品味。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20dramatic%20lighting%20and%20shadows%2C%20film%20noir%20aesthetic%2C%20crime%20scene%20investigation%20atmosphere%2C%20deep%20contrast%2C%20suspenseful%20mood%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '韩剧热播榜：今夏最值得追的5部新剧',
    subtitle: '追剧指南',
    desc: '今年夏天韩剧市场精彩纷呈，从浪漫爱情到悬疑惊悚，密桃视频为您推荐5部不容错过的热门新剧，追剧日历已更新。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20style%20cinematic%20scene%20with%20soft%20romantic%20lighting%2C%20cherry%20blossom%20aesthetic%2C%20warm%20pastel%20and%20golden%20tones%2C%20dreamy%20atmosphere%2C%20elegant%20composition%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '动漫新番速递：2026夏季档完整追番表',
    subtitle: '新番指南',
    desc: '2026夏季新番已全面上线！密桃视频动漫频道整理完整追番时间表，从热血战斗到治愈日常，你的夏季追番计划从这里开始。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Anime%20studio%20workspace%20with%20colorful%20animation%20cells%20and%20drawing%20tools%2C%20vibrant%20Japanese%20anime%20aesthetic%2C%20creative%20atmosphere%2C%20warm%20and%20vivid%20lighting%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-star-line text-accent-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">焦点专题</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11">精选深度专题内容，探索影视世界的更多可能</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className={`group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all cursor-pointer ${
                i < 2 ? 'lg:col-span-3 md:col-span-2' : ''
              }`}
            >
              <div className={`flex flex-col ${i < 2 ? 'lg:flex-row' : ''}`}>
                <div className={`overflow-hidden bg-background-200 ${i < 2 ? 'lg:w-2/5 lg:shrink-0' : ''}`}>
                  <div className={i < 2 ? 'aspect-[16/9] lg:aspect-[4/3] lg:h-full' : 'aspect-[16/9]'}>
                    <img
                      src={item.imgUrl}
                      alt={`${item.title} - 密桃视频焦点专题`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="p-4 md:p-6 flex flex-col justify-center">
                  <span className="inline-block w-fit px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-2 whitespace-nowrap">
                    {item.subtitle}
                  </span>
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}